import { useState } from "react";
import { sendTwoFaAction } from "../actions/send-verify-twofa.action";
import { verifyTwoFaAction } from "../actions/validate-verify-twofa.action";

export function useTwoFa() {
  const [isLoading, setIsLoading] = useState(false);

  const currentSession = JSON.parse(localStorage.getItem("pendingActivationAccount") || "{}");
  const { uid, activationToken } = currentSession;

  const sendTwoFa = async (twoFaMethod) => {
    setIsLoading(true);
    try {
      await sendTwoFaAction({ uid, activationToken, twoFaMethod });
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  };

  const verifyTwoFa = async (twoFaMethod, code) => {
    setIsLoading(true);

    try {
      const response = await verifyTwoFaAction({ uid, activationToken, twoFaMethod, code });

      if (!response?.data?.token) {
        throw new Error("Invalid verification code");
      }

      sessionStorage.setItem("token", response.data.token);
      sessionStorage.setItem("refresh_token", response.data.refresh_token.token);
      return true;
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    //Actions
    sendTwoFa,
    verifyTwoFa,

    //Properties
    isLoading,
  };
}
